var map = {
	"./banner-arguments-and-evidence.png": 2955,
	"./banner-beach.png": 2956,
	"./banner-city.png": 2957,
	"./banner-connections.png": 2958,
	"./banner-desert.png": 2959,
	"./banner-details.png": 2960,
	"./banner-developments-and-interactions.png": 2961,
	"./banner-fairyland.png": 2962,
	"./banner-farm.png": 2963,
	"./banner-forest.png": 2964,
	"./banner-how-to.png": 2965,
	"./banner-inferences.png": 2966,
	"./banner-informational.png": 2967,
	"./banner-jungle.png": 2968,
	"./banner-key-ideas.png": 2969,
	"./banner-lake.png": 2970,
	"./banner-media-and-formats.png": 2971,
	"./banner-mushrooms.png": 2972,
	"./banner-narrative.png": 2973,
	"./banner-persuasive.png": 2974,
	"./banner-purpose-and-points-of-view.png": 2975,
	"./banner-review.png": 2976,
	"./banner-reviews.png": 2977,
	"./banner-savannah.png": 2978,
	"./banner-sky.png": 2979,
	"./banner-space.png": 2980,
	"./banner-text-structure.png": 2981,
	"./banner-tundra.png": 2982,
	"./banner-underwater.png": 2983,
	"./banner-vocabulary.png": 2984
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 380;



//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-banners .\.png*
// module id = 380
// module chunks = 0